<script lang="ts">
    import type { WishListType } from '../../store/types';
    import { formatDate, formatMoney } from '../../helpers/common';
    import lang from '../../lang/language';
    import { currentLangIsJapanese } from '../../helpers/url';

    export let wishlist: any;
    export let remove: any;
</script>

<div class="wishlist-box">
    <div class="image">
        <img src={wishlist?.Thumbnail} alt="" />
    </div>
    <div class="short-info">
        <div class="name one-liner">{wishlist?.Name}</div>
        <div class="desc two-liner">
            {formatDate(wishlist?.Commence, 'dd-MM-yyyy hh:mm')}
        </div>
        <div class="desc one-liner">
            {wishlist?.Guest}
            {wishlist?.Type === 3 ? lang.item : lang.guest}
        </div>
        {#if wishlist?.Type === 0}
            <div class="desc one-liner">
                {wishlist?.Night}
                {lang.night}
            </div>
        {/if}
        <div class="price">
            <!-- {!currentLangIsJapanese() && wishlist?.Price > 0 ? lang.from : ''} -->
            ¥{formatMoney(wishlist?.Price)}
            <!-- {currentLangIsJapanese() && wishlist?.Price > 0 ? lang.from : ''} -->
        </div>
    </div>
    <div class="delete-col">
        <div class="delete-button" on:click={remove}>
            <i class="fas fa-times" />
        </div>
    </div>
</div>

<style>
    .wishlist-box {
        overflow: hidden;
        display: flex;
        flex-direction: row;
        width: 95%;
        height: 125px;
        margin: 10px auto;
        border-radius: 10px;
        border: 1px solid lightgrey;
    }

    .wishlist-box > .image {
        flex: 1;
    }

    .wishlist-box > .image > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .wishlist-box > .short-info {
        flex: 2;
        padding: 10px;
        line-height: 20px;
    }

    .wishlist-box > .delete-col {
        flex: 0.2;
    }

    :global(.delete-button) {
        background-image: url('../images/close.png');
        background-size: 40%;
        background-position: center;
        background-repeat: no-repeat;
        height: 25px;
        padding: 7px;
        cursor: pointer;
        width: 25px;
    }

    .info > div {
        margin-bottom: 3px;
    }

    .desc {
        font-size: 14px;
        text-align: left;
    }

    .name {
        font-size: 15px;
        font-weight: bold;
    }

    .price {
        font-size: 15px;
        font-weight: bold;
    }
</style>
